import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService implements OnDestroy {
  private pending = 0;
  private navigating = false;
  private readonly state = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.state.asObservable();
  private readonly axios = require('axios');
  private readonly requestInterceptor: number;
  private readonly responseInterceptor: number;
  private readonly navigation: Subscription;

  constructor(private zone: NgZone, router: Router) {
    this.requestInterceptor = this.axios.interceptors.request.use(config => {
      if (config.showLoading !== false) {
        config.appLoadingTracked = true;
        this.begin();
      }
      return config;
    });
    this.responseInterceptor = this.axios.interceptors.response.use(response => {
      this.finishAxios(response.config);
      return response;
    }, error => {
      this.finishAxios(error.config);
      return Promise.reject(error);
    });
    this.navigation = router.events.subscribe(event => {
      if (event instanceof NavigationStart) { this.navigating = true; }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.navigating = false;
      }
      this.publish();
    });
  }

  begin(): void { this.pending++; this.publish(); }
  end(): void { this.pending = Math.max(0, this.pending - 1); this.publish(); }

  private finishAxios(config: any): void {
    if (config && config.appLoadingTracked) {
      config.appLoadingTracked = false;
      this.end();
    }
  }

  private publish(): void {
    this.zone.run(() => this.state.next(this.pending > 0 || this.navigating));
  }

  ngOnDestroy(): void {
    this.navigation.unsubscribe();
    this.axios.interceptors.request.eject(this.requestInterceptor);
    this.axios.interceptors.response.eject(this.responseInterceptor);
  }
}
